import { createFileRoute } from '@tanstack/react-router';
import { ArticlesScreen } from '@/screens/article/ArticlesScreen';

export const Route = createFileRoute('/admin/articles')({
  component: ArticlesScreen,
});